/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { View, type ViewStyle } from 'react-native';
import { surfaceCardStyles as styles } from './surfaceCards.styles';

type Props = {
  children: React.ReactNode;
  style?: ViewStyle;
};

/** Bloque superior neutro: título, búsqueda y acciones (sin acento ámbar de filtros). */
export function ScreenHeroCard({ children, style }: Props) {
  return <View style={[styles.heroCard, style]}>{children}</View>;
}
